<template>
    <div class="hello">Hello</div>
</template>
<script>
    export default {
        name: "Tooltip"
    };
</script>